export default "__VITE_ASSET__HhbTnwed__"